<template>
    <div class="grzx">
        <div class="grzxc">
            <div class="gritem" @click="go($event)">
                <div class="gileft">
                    <img src="../../assets/wygl/wuye.png" alt="">
                    <span>业主缴费</span>
                </div>
                <div class="giright">
                    <img src="../../assets/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go($event)" >
                <div class="gileft">
                    <img src="../../assets/wygl/chewei.png" alt="">
                    <span>车位缴费</span>
                </div>
                <div class="giright">
                    <img src="../../assets/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go($event)">
                <div class="gileft">
                    <img src="../../assets/wygl/jfjl.png" alt="">
                    <span>缴费记录</span>
                </div>
                <div class="giright">
                    <img src="../../assets/you.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showfz:false,
            openId:'',
            wdxxnum:'',
            iszhuce:'',//是否注册
            userinfo:[],
            now:''
        }
    },
    created () {
        var that = this
    },

    mounted() {
        var that = this
    },
    methods: {
        //获取未读信息
        getwd(){
            var that = this
            axios.get(that.Zfip.ip+'/websites/_ext/zhsq/czfmobile/getNum.jsp',{
                params:{
                    openId:that.openId
                }
            }).then(result=>{
                that.wdxxnum = result.data.num
                
            })
        },
        go(event){
            var that =this
            var name = event.target.innerHTML
            if(name.indexOf('业主缴费') != -1){
                this.$router.push({ path: "/wyfw/wyjf", query: {} });
            }
            if(name.indexOf('车位缴费') != -1){
                this.$router.push({ path: "/wyfw/cheweijf", query: {} });
            }
            if(name.indexOf('缴费记录') != -1){
                this.$router.push({ path: "/wyfw/jfjl", query: {} });
            }
        }
    },
}
</script>
<style lang="less">
    .grzx{
        height: 100vh;
        width: 100%;
        display: flex;
        background-color: #eeeeee;
        flex-direction: column;
        align-items: center;
        .grzxc{
            width: calc(100% - 6%);
            .gritem{
                margin-top: 15px;
                height: 60px;
                width: 100%;
                display: flex;
                background: #fff;
                align-items: center;
                border-radius: 10px;
                justify-content: space-between;
                .gileft{
                    display: flex;
                    height: 100%;
                    align-items: center;
                    width: 50%;
                    img{
                        height: 25px;
                        width: 25px;
                        margin-left: 20px;
                    }
                    span{
                        margin-left: 10px;
                    }
                }
                .van-badge{
                    margin-left: 20%;
                }
                .giright{
                    margin-right: 20px;
                    height: 100%;
                    align-items: center;
                    display: flex;
                    flex-direction:row-reverse
                    
                }
            }
            .tingche {
                height: 20px;
                width: 20px;
                border-radius: 50%;
                border: #00a8ff 1px solid;
                color: #00a8ff;
                font-size: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
</style>